import { render, staticRenderFns } from "./updateHistory.vue?vue&type=template&id=b13e2fcc&scoped=true"
import script from "./updateHistory.vue?vue&type=script&lang=js"
export * from "./updateHistory.vue?vue&type=script&lang=js"
import style0 from "./updateHistory.vue?vue&type=style&index=0&id=b13e2fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13e2fcc",
  null
  
)

export default component.exports